/*
 * @Author       : 程哲林
 * @Date         : 2022-05-18 21:31:43
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-09-07 14:05:33
 * @FilePath     : /marketing-introduce-ssr/components/Activity/InviteFriends/index.tsx
 * @Description  : 未添加文件描述
 */
import { Toast } from 'antd-mobile';
import cx from 'classnames';
import { Button } from 'components/Activity/Button';
import Cookies from 'js-cookie';
import QRCode from 'qrcode';
import React, {
  useCallback,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState
} from 'react';

import posterInfoImg from '@/assets/activity/img24.png';
import { isBrowser, OPEN_APP } from '@/common/const';
import { generateInviteCode, shareEvent } from '@/services/activity';
import {
  getCurrPlatform,
  isWXBrowser,
  openMiniApp,
  qsParse,
  reportError,
  shareWx
  // getCurrPlatformText,
} from '@/utils';
import { generateShareMiniQrcode, generateShareUrl } from '@/utils/activity';
// import Link from 'next/link'
import { useLongPress } from '@/utils/hooks';
import { CanvasRenderer } from '@/utils/poster';
import { sensClickInitiative, sensElementView } from '@/utils/sensors';

import { ActionSheet } from '../ActionSheet';
import styles from './index.module.scss';

export interface ActivityGuideFlowConfigs {
  id: string;
  guideType: string;
  guideSubject: string;
  guideRole: string;
  followed: boolean;
  data: {
    guideFlowQrCode: string;
  };
}

const isWx = isWXBrowser();

let platformMemo = 0;
let inviteCodeMemo = '';
async function shareFunc({
  type,
  actId,
  channel,
  channelNo,
  inviteCode,
  sceneLabel,
  // inviteStatus,
  webPageId
}: {
  type: number;
  actId: any;
  channel: any;
  channelNo?: string;
  inviteCode: string;
  sceneLabel: string;
  webPageId?: string;
  inviteStatus?: boolean;
}) {
  const eventNameArr = [
    '邀友海报页点击分享给好友',
    '邀友海报页点击分享到朋友圈',
    '邀友海报页长按海报'
  ];
  const shareTypeArr = ['WECHAT_FRIEND', 'WECHAT_FRIEND_CIRCLE', 'PRESS_SAVE'];
  shareEvent({
    channel,
    channelNo,
    eventName: eventNameArr[type],
    eventParam: {
      activityId: actId,
      uid: Cookies.get('uid'),
      posterId: '0',
      inviteCode
    },
    pageUrl: window.location.href,
    shareType: shareTypeArr[type],
    userPlatform: platformMemo
  });

  if (type === 2) {
    sensClickInitiative({
      $element_name: '运营活动活动页_邀友共得分享元素点击',
      $element_content: '海报',
      activity_id: actId,
      topic_name: labelName(sceneLabel),
      activity_label: `邀友共得`,
      material_ids: [webPageId || ''],
      $element_type: '海报'
    });
  }
}

function imageInfo(src: string): Promise<{
  height: number;
  width: number;
}> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      resolve({
        width: img.width,
        height: img.height
      });
    };
    img.onerror = (e) => {
      reject(e);
    };
  });
}

async function renderPoster(
  name: string,
  data: any,
  shareLink = '',
  sharePostImg = '',
  inviteData?: any
) {
  try {
    const $ele = document.getElementById('J-pimg') as HTMLImageElement;

    if (!$ele || $ele?.getAttribute('src')) {
      return;
    }

    const { miniProgramCode, miniAppId } = inviteData || {};

    let qrCodeImg = '';
    let useMiniAppId = miniAppId;

    Toast.loading('海报生成中', 10);
    if (useMiniAppId === 'mini_program_code') {
      const result = await generateShareMiniQrcode({ miniAppId, miniProgramCode });
      qrCodeImg = result.qrCodeImg;
      useMiniAppId = result.miniAppId;
    }

    let renderData: any = [];

    const figure = data?.find(({ componentType, moduleImageExtVo = {} }: any) => {
      return (
        ['FIGURE_CAPTIONS', 'MODULE_IMAGE'].includes(componentType) ||
        moduleImageExtVo.presentationStyle === 'ONE'
      );
    });

    if (!shareLink) {
      Toast.hide();
      return;
    }

    if (!qrCodeImg) {
      qrCodeImg = await QRCode.toDataURL(shareLink, {
        errorCorrectionLevel: 'L'
      });
    }

    let cr: CanvasRenderer;

    if (!figure && !sharePostImg) {
      cr = new CanvasRenderer({
        width: 672,
        height: 1160,
        dpr: 1
      });

      renderData = [
        {
          type: 'img',
          src: 'https://jojostorage.tinman.cn/h5/static/poster/group-buy.jpg',
          style: {
            x: 0,
            y: 0,
            width: 672,
            height: 1160
          }
        },
        {
          type: 'img',
          src: qrCodeImg,
          style: {
            x: 420,
            y: 904,
            width: 220,
            height: 220
          }
        }
      ];
    } else {
      const cover =
        sharePostImg ||
        (figure?.commonExtVo
          ? figure.commonExtVo.backImage
          : figure.moduleImageExtVo.moduleData[0].backImage);
      const { height, width } = await imageInfo(cover);

      const coverHeight = Math.round((672 / width) * height);

      cr = new CanvasRenderer({
        width: 672,
        height: coverHeight + 244,
        dpr: 1
      });

      renderData = [
        {
          type: 'img',
          src: cover,
          style: {
            x: 0,
            y: 0,
            width: 672,
            height: coverHeight
          }
        },
        {
          type: 'img',
          src: posterInfoImg,
          style: {
            x: 0,
            y: coverHeight,
            width: 672,
            height: 244
          }
        },
        {
          type: 'img',
          src: qrCodeImg,
          style: {
            x: 450,
            y: coverHeight + 20,
            width: 200,
            height: 200
          }
        },
        {
          type: 'font',
          content: name.replace(/(.{6}).*/, '$1...'),
          style: {
            x: 48,
            y: coverHeight + 52,
            fontSize: 36,
            color: `#ACB2BB`,
            // color: `red`,
            textAlign: 'left',
            fontWeight: 600
          }
        }
      ];
    }

    const crData = await cr.render(renderData);

    const img = crData.toDataURL('image/jpeg', 0.8);

    /* if (!document.getElementById('j-poster-style')) {
      const sc = renderData[0].style.width / renderData[0].style.height
      const style = document.createElement('style')
      style.id = 'j-poster-style'
      const attribute = sc >= 0.73 && window.outerWidth <= 750 ? 'width' : 'height'
      style.innerHTML = `#J-pimg{${
        attribute
      }:100%;}`
      document.head.appendChild(style)
    }
     */
    $ele.setAttribute('src', img);
  } catch (e) {
    reportError(e);
  }

  Toast.hide();
}

const MD_KEY = 'j-md-key';
const ACT_TYPE = '邀友共得';

function labelName(label = '') {
  const obj: any = {
    iftw_zdqxk: '组队抢先看',
    iftw_xsz1d4: '限时赠一得四',
    iftw_z1d1: '赠一得一'
  };

  return obj[label] || '赠一得一';
}

const labelMap: any = {
  // 组队抢先看
  iftw_zdqxk: {
    t1: '还差',
    t2: '组队',
    qrTxt1: '关注公众号即可加入队伍',
    btnTxt: '立即组队',
    finishTxt: '组队成功',
    baseTxt: '组队',
    // 新用户
    nBtnTxt: '立即组队',
    // 老用户
    oBtnTxt: '去组队',
    // 非新用户
    noBtnTxt: '立即查看',

    nDesc: '加入组队，与我一起阅读口碑内容吧',
    oDesc: '非常抱歉，只有叫叫新用户才能加入组队， 您也可以发起组队，邀请1位好友抢先看！',
    noDesc: '非常抱歉，只有叫叫新用户才能加入组队。叫叫为您准备了其它福利，点击下方按钮查看吧'
  },
  // 限时赠一得四
  iftw_xsz1d4: {
    t1: '只差',
    t2: '领取',
    qrTxt1: '关注公众号即可领取内容',
    btnTxt: '立即邀请',
    finishTxt: '邀请成功',
    baseTxt: '邀请',
    nBtnTxt: '立即领取',
    oBtnTxt: '开始阅读',
    noBtnTxt: '立即邀请',

    nDesc: '我发现这些口碑内容可以限时免费领，抓紧时间和我一起领取吧！',
    oDesc: '您是叫叫的系统包用户，这些内容己经全部为您解锁，无需再次领取。点击按钮开始阅读！',
    noDesc: '非常抱歉，只有叫叫新用户才能领取。您也可以邀请1位好友，一起解锁内容！'
  },
  // 赠一得一
  iftw_z1d1: {
    t1: '再赠',
    t2: '领取',
    qrTxt1: '关注公众号即可领取内容',
    btnTxt: '立即赠送',
    finishTxt: '赠送成功',
    baseTxt: '赠送',
    nBtnTxt: '立即领取',
    oBtnTxt: '开始阅读',
    noBtnTxt: '立即赠送',

    nDesc: '我发现了一个很适合孩子成长的内容，赠送给你免费阅读！',
    oDesc: '您是叫叫的系统包用户，这些内容已经全部为您解锁，无需再次领取，点击按钮开始阅读！',
    noDesc: '非常抱歉，只有叫叫新用户才能领取。您也可以发起赠送，邀请1位好友一起阅读！'
  }
};

const InviteFriends = React.memo(
  ({
    channel,
    channelNo,
    activityId,
    actCode,
    webPageId,
    invite,
    configs = [],
    userInfo,
    components,
    onRef,
    share,
    sceneLabel = 'iftw_z1d1',
    teams = [],
    sharePostImg,
    banduNewUser,
    jumpAppActUrl,
    banduYearCourseUser
  }: {
    channel?: string;
    channelNo?: string;
    activityId: string;
    actCode: string;
    webPageId: string;
    onRef: any;
    // 是否为被邀请人
    invite: boolean;
    configs: ActivityGuideFlowConfigs[];
    components: any;
    teams: {
      avatar: string;
      nickname: string;
    }[];
    sceneLabel: string;
    jumpAppActUrl: string;
    sharePostImg: string;
    banduNewUser: boolean;
    banduYearCourseUser: boolean;
    share: {
      shareImage: null | string;
      shareDesc: null | string;
      shareTitle: null | string;
    };
    userInfo: {
      noCourse: boolean;
      avatar: string;
      nickname: string;
      prizeUserCount: number;
      prizeMaxLimit: number;
      shared: boolean;
      parentAvatar: string;
      parentNickname: string;
    };
  }) => {
    const [comState, setComState] = useState(() => {
      if (isBrowser && window.location.search.includes('iqr=1')) {
        return 5;
      } else {
        return 0;
      }
    });

    const longPressEvent = useLongPress(
      () => {
        shareFunc({
          type: 2,
          actId: activityId,
          channel,
          channelNo,
          inviteCode: inviteCodeMemo,
          sceneLabel,
          inviteStatus: invite,
          webPageId
        });
      },
      {
        isPreventDefault: true,
        delay: 300
      }
    );

    // 推荐人被推荐人关注的配置信息
    const [recommendUser, passiveUser] = useMemo(() => {
      const findRecommendIndex = configs.findIndex(({ guideRole }) => {
        return guideRole === 'INITIATIVE';
      });

      const findPassiveIndex = findRecommendIndex ? 0 : 1;

      return [configs[findRecommendIndex] || { followed: true }, configs[findPassiveIndex] || {}];
    }, [configs]);

    const isReceive = useRef(false);
    const styleCfg = useMemo(() => {
      let obj = {};

      const labelArr = Object.keys(labelMap);
      const label = labelArr.includes(sceneLabel) ? sceneLabel : 'iftw_z1d1';

      const baseObj = labelMap[label];

      // 排除已关注公众号的用户
      isReceive.current = (banduNewUser || userInfo.noCourse) && !passiveUser.followed;
      if (isReceive.current) {
        // 新用户
        obj = {
          pBtnTxt: baseObj.nBtnTxt,
          pDesc: baseObj.nDesc
        };
      } else if (banduYearCourseUser) {
        // 年课用户(系统包老用户)
        obj = {
          pBtnTxt: baseObj.oBtnTxt,
          pDesc: baseObj.oDesc,
          jumpUrl: ['iftw_zdqxk'].includes(label) ? '' : jumpAppActUrl
        };
      } else {
        // 非年课老用户（非系统包老用户）
        obj = {
          pBtnTxt: baseObj.noBtnTxt,
          pDesc: baseObj.noDesc,
          jumpUrl: ['iftw_z1d1', 'iftw_xsz1d4'].includes(label) ? '' : jumpAppActUrl
        };
      }

      return Object.assign(baseObj, obj);
    }, [
      banduNewUser,
      banduYearCourseUser,
      jumpAppActUrl,
      passiveUser.followed,
      sceneLabel,
      userInfo.noCourse
    ]);

    const getCode = useCallback(async () => {
      const platform = await getCurrPlatform(true);
      platformMemo = platform;

      const { code, data, message } = await generateInviteCode<{
        inviteCode: string;
        scanCodeJumpUrl: string;
        shareHub: string;
        useShortUrl: boolean;
      }>({
        activityId,
        channel,
        channelNo,
        parentPlatform: platform,
        posterId: '0',
        teacherId: Cookies.get(`s-teacherId-${activityId}`) || ''
      });

      if (code !== 'SUCCESS') {
        Toast.fail(message || '邀请码生成失败');
        return { shareLink: '', inviteCode: '' };
      }

      const { orderSource } = qsParse();
      const { useShortUrl, scanCodeJumpUrl } = data;
      const shareLink = await generateShareUrl({
        useShortUrl,
        scanCodeJumpUrl,
        channel,
        channelNo,
        platform
      });
      let url = shareLink;
      if (orderSource) {
        url += `${shareLink.includes('?') ? '&' : '?'}orderSource=${orderSource}`;
      }

      inviteCodeMemo = data.inviteCode;
      return { shareLink: url, inviteCode: data.inviteCode, inviteData: data };
    }, [activityId, channel, channelNo]);

    useImperativeHandle(onRef, () => {
      return {
        change: (val: number) => {
          if (__store.isLogin) {
            setComState(val);
          }
        }
      };
    });

    // 生成海报
    useEffect(() => {
      if (comState === 7) {
        getCode()
          .then(({ shareLink, inviteData }) => {
            renderPoster(userInfo.nickname, components, shareLink, sharePostImg, inviteData);
          })
          .catch(reportError);
      }
    }, [comState, components, getCode, sharePostImg, userInfo.nickname]);

    const renderPopup = useCallback(() => {
      ActionSheet.showInstance(
        <div className={styles['share-md']}>
          <div className={styles.ctx}>
            <img
              className={styles.img}
              src={require('../../../assets/activity/img37.png')}
              alt=''
            />
            <div className={styles.txt}>关注公众号，及时获取{styleCfg.baseTxt}进度</div>
            <div className={styles.btns}>
              <button
                type='button'
                onClick={() => {
                  ActionSheet.removeInstance(MD_KEY);
                }}
                className={styles.btn}>
                以后再说
              </button>
              <button
                type='button'
                onClick={() => {
                  openMiniApp(`${window.location.href}&iqr=1`);
                }}
                className={cx(styles.btn, styles.btn2)}>
                立即关注
              </button>
            </div>
          </div>
        </div>,
        MD_KEY
      );
    }, [styleCfg.baseTxt]);

    const init = useCallback(
      (pop?: boolean) => {
        if (invite) {
          // 被邀请人
          if (teams.length >= 2) {
            // 判断被邀请人是否获取到奖励，如果获取到奖励
            setComState(8);
          } else if (userInfo.noCourse || banduNewUser) {
            // 无课用户：完全纯新用户；伴读新用户：年课结营超30天，要么体验包结营超14天，完全纯新用户

            // 被邀请人已经关注,走非年课老用户逻辑
            if (passiveUser.followed) {
              setComState(6);
            } else {
              setComState(4);
            }
          } else {
            setComState(6);
          }
        } else {
          if (userInfo.shared && !recommendUser.followed) {
            // 用户分享了，但没有关注
            if (isWx) {
              setComState(3);
            } else {
              setComState(2);
              if (pop) {
                renderPopup();
              }
            }
          } else if (__store.isLogin) {
            setComState(2);
          }
        }
      },
      [
        banduNewUser,
        invite,
        passiveUser.followed,
        recommendUser.followed,
        renderPopup,
        userInfo.noCourse,
        userInfo.shared,
        teams
      ]
    );

    // 判断该展示哪一个状态
    useEffect(() => {
      if (isBrowser && window.location.search.includes('iqr=1')) {
        return;
      }

      init(true);
    }, [init]);

    const onWxShare = useCallback(
      async (scene: number) => {
        const { shareLink, inviteCode } = await getCode();

        shareFunc({
          type: scene,
          actId: activityId,
          channel,
          channelNo,
          inviteCode,
          sceneLabel
        });

        const { title } = document;

        sensClickInitiative({
          $element_name: '运营活动活动页_邀友共得分享元素点击',
          $element_content: scene ? '朋友圈' : '微信好友',
          activity_id: activityId,
          topic_name: labelName(sceneLabel),
          activity_label: `邀友共得`,
          material_ids: [webPageId],
          $element_type: '分享控件'
        });

        shareWx(
          {
            scene,
            shareType: 0,
            title: share.shareTitle || title,
            desc: share.shareDesc || title,
            image: share.shareImage || '',
            url: shareLink
          },
          () => {
            if (recommendUser.followed) {
              setComState(2);
              // renderPopup()
            } else {
              setComState(2);
              renderPopup();
            }
          }
        );
      },
      [
        activityId,
        channel,
        channelNo,
        getCode,
        recommendUser.followed,
        renderPopup,
        sceneLabel,
        share.shareDesc,
        share.shareImage,
        share.shareTitle,
        webPageId
      ]
    );

    useEffect(() => {
      if (comState) {
        const typeName: any = {
          1: '分享控件',
          3: '分享者',
          4: '可领取',
          5: '领取者',
          6: '不可领取',
          7: '海报',
          8: '领取者'
        };
        const name = [
          '',
          '运营活动活动页_邀友共得分享元素曝光',
          '运营活动活动页_立即赠送好友按钮曝光',
          '运营活动活动页_关注公众号弹窗曝光',
          '运营活动活动页_邀友共得领取按钮曝光',
          '运营活动活动页_关注公众号弹窗曝光',
          '运营活动活动页_非新用户提示曝光',
          '运营活动活动页_邀友共得分享元素曝光',
          '运营活动活动页_关注公众号弹窗曝光'
        ];

        sensElementView({
          c_element_name: name[comState],
          channel,
          channelNo,
          material_type: typeName[comState] || '',
          activity_id: activityId,
          material_ids: [webPageId],
          topic_name: labelName(sceneLabel),
          activity_label: `邀友共得`
        });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [comState]);

    useEffect(() => {
      const $mbottom = document.getElementById('j-mbottom');
      const $ele = document.querySelector('.j-share-panel > div');

      if ($mbottom && $ele) {
        $mbottom.style.height = `${$ele.clientHeight}px`;
      }

      return () => {
        $mbottom?.removeAttribute('style');
      };
    }, [comState]);

    const isUserPrize = teams.length >= 2;

    if (configs.length <= 0) {
      return null;
    }

    switch (comState) {
      case 1:
        // APP分享
        return (
          <div className={cx(styles['share-panel'], styles.mask, 'j-share-panel')}>
            <div className={styles.ct}>
              <div className={styles.hd}>
                <div className={styles.btns}>
                  <button
                    type='button'
                    onClick={() => {
                      onWxShare(0);
                    }}
                    className='ui-icon ui-icon__img37'
                  />
                  <button
                    type='button'
                    onClick={() => {
                      onWxShare(1);
                    }}
                    className='ui-icon ui-icon__img36'>
                    <img src={require('../../../assets/activity/img38.png')} alt='' />
                  </button>
                </div>
                {/* <div className={styles.tit}>
                  赠送该内容，邀请好友一起开始阅读吧！
                </div> */}
              </div>
              <button
                type='button'
                onClick={() => {
                  /* if (invite) {
                    setComState(6)
                  } else {
                    setComState(2)
                  } */
                  init();
                }}
                className={styles.cancel}>
                取消
              </button>
            </div>
          </div>
        );

      case 2:
        // 组队列表
        return (
          <div className={cx('j-share-panel', styles['share-panel'])}>
            <div
              className={cx(styles.ct, styles.ct4, {
                [styles.ct5]: isUserPrize
              })}>
              {isUserPrize ? (
                <div className={styles.point}>
                  <span>{styleCfg.finishTxt}，点击上方专辑开始阅读吧</span>
                  <i className='ui-icon ui-icon__img44' />
                </div>
              ) : (
                <div className={styles.tips}>
                  <div>
                    {styleCfg.t1}
                    <strong>1</strong>人{styleCfg.t2}
                  </div>
                  <a
                    href={`/activity/details/invite?actId=${activityId}&label=${sceneLabel}&actCode=${actCode}`}
                    onClick={() => {
                      sensClickInitiative({
                        $element_name: '运营活动活动页_查看赠送详情按钮点击',
                        $element_content: ACT_TYPE,
                        // $element_type: '非新用户',
                        activity_id: activityId,
                        topic_name: labelName(sceneLabel),
                        activity_label: `邀友共得`,
                        material_ids: [webPageId]
                      });
                    }}
                    className={cx(styles.detail)}>
                    <span>{styleCfg.baseTxt}详情</span>
                    <i className='ui-icon ui-icon__img40' />
                  </a>
                </div>
              )}

              <div className={styles.list}>
                <div className={styles.head}>
                  <div className={styles.item}>
                    <img src={teams[0].avatar} alt='' />
                  </div>
                  {isUserPrize ? (
                    <div className={styles.item}>
                      <img src={teams[1].avatar} alt='' />
                    </div>
                  ) : (
                    <div
                      onClick={() => {
                        setComState(isWx ? 7 : 1);
                        sensClickInitiative({
                          $element_name: '运营活动活动页_立即赠送好友按钮点击',
                          $element_content: ACT_TYPE,
                          topic_name: labelName(sceneLabel),
                          // $element_type: '非新用户',
                          activity_id: activityId,
                          activity_label: `邀友共得`,
                          material_ids: [webPageId]
                        });
                      }}
                      className={styles.item}>
                      <img src={require('../../../assets/activity/img36.png')} alt='' />
                    </div>
                  )}
                </div>

                {isUserPrize ? (
                  <a
                    href={`/activity/details/invite?actId=${activityId}&label=${sceneLabel}&actCode=${actCode}`}
                    onClick={() => {
                      sensClickInitiative({
                        $element_name: '运营活动活动页_查看赠送详情按钮点击',
                        $element_content: ACT_TYPE,
                        // $element_type: '非新用户',
                        activity_id: activityId,
                        topic_name: labelName(sceneLabel),
                        activity_label: `邀友共得`,
                        material_ids: [webPageId]
                      });
                    }}
                    className={cx(styles.detail)}>
                    <span>{styleCfg.baseTxt}详情</span>
                    <i className='ui-icon ui-icon__img40' />
                  </a>
                ) : (
                  <Button
                    className={styles.btn}
                    finger
                    disabled={isUserPrize}
                    onClick={() => {
                      setComState(isWx ? 7 : 1);
                      sensClickInitiative({
                        $element_name: '运营活动活动页_立即赠送好友按钮点击',
                        $element_content: ACT_TYPE,
                        activity_id: activityId,
                        activity_label: `邀友共得`,
                        material_ids: [webPageId],
                        topic_name: labelName(sceneLabel)
                      });
                    }}>
                    {styleCfg.btnTxt}
                  </Button>
                )}
              </div>
            </div>
          </div>
        );
      case 3:
        // 邀请人关注公众号
        return (
          <div className={cx('j-share-panel', styles['share-panel'])}>
            <div className={styles.ct}>
              <div
                onClick={() => {
                  setComState(2);
                }}
                className={cx(styles.close, 'ui-icon', 'ui-icon__img18')}
              />
              <div className={styles.hd}>
                <img className={styles.qrcode} src={recommendUser?.data?.guideFlowQrCode} alt='' />
                <div className={styles['qc-tit']}>长按上方二维码</div>
                <div className={styles['qc-desc']}>
                  前往关注公众号，及时获取{styleCfg.baseTxt}进度
                </div>
              </div>
            </div>
          </div>
        );
      case 4:
        // 头像描述
        return (
          <div className={cx('j-share-panel', styles['share-panel'])}>
            <div className={cx(styles.ct, styles.ct1)}>
              <div className={styles.user}>
                <div className={styles['u-pic']}>
                  <img src={userInfo.parentAvatar} alt='' />
                  <span className='fn-cut'>{userInfo.parentNickname}</span>
                </div>
                <div className={styles.bubble}>
                  {styleCfg.pDesc}
                  <i className='ui-icon ui-icon__img46' />
                </div>
              </div>
              <Button
                onClick={() => {
                  const isNew = banduNewUser || userInfo.noCourse;
                  sensClickInitiative({
                    $element_name: '运营活动活动页_邀友共得领取按钮点击',
                    $element_content: ACT_TYPE,
                    activity_id: activityId,
                    activity_label: `邀友共得`,
                    material_ids: [webPageId],
                    topic_name: labelName(sceneLabel),
                    $element_type: '可领取'
                  });
                  if (!isNew) {
                    return setComState(6);
                  }

                  if (passiveUser.followed) {
                    setComState(5);
                  } else {
                    if (isWx) {
                      setComState(5);
                    } else {
                      openMiniApp(`${window.location.href}&iqr=1`);
                    }
                  }

                  return null;
                }}
                // subTitle={`已有${userInfo.prizeUserCount}人领取 限${userInfo.prizeMaxLimit}人`}
              >
                {styleCfg.pBtnTxt}
              </Button>
            </div>
          </div>
        );

      case 5:
        // 被邀请人关注公众号
        return (
          <div className={cx('j-share-panel', styles['share-panel'])}>
            <div className={cx(styles.ct, styles.ct2)}>
              <div
                onClick={() => {
                  // setComState(0)
                  init();
                }}
                className={cx(styles.close, 'ui-icon', 'ui-icon__img18')}
              />
              <img className={styles.qrcode1} src={passiveUser?.data?.guideFlowQrCode} alt='' />
              <div className={styles.tit}>长按二维码</div>
              <div className={styles.txt1}>{styleCfg.qrTxt1}</div>
            </div>
          </div>
        );
      case 6:
        // 多文案面板
        return (
          <div className={cx('j-share-panel', styles['share-panel'])}>
            <div className={cx(styles.ct, styles.ct1)}>
              <div className={styles.txt2}>{styleCfg.pDesc}</div>
              <Button
                onClick={() => {
                  const link = styleCfg.jumpUrl;
                  if (link) {
                    if (/^http.*/gim.test(link)) {
                      window.location.href = link;
                    } else {
                      window.location.href = `${OPEN_APP}${encodeURIComponent(link)}`;
                    }
                  } else {
                    if (isWx) {
                      setComState(7);
                    } else {
                      setComState(1);
                    }
                  }

                  sensClickInitiative({
                    $element_name: '运营活动活动页_立即赠送好友按钮点击',
                    $element_content: ACT_TYPE,
                    $element_type: '非新用户',
                    activity_id: activityId,
                    activity_label: `邀友共得`,
                    material_ids: [webPageId],
                    topic_name: labelName(sceneLabel)
                  });
                }}>
                {styleCfg.pBtnTxt}
              </Button>
            </div>
          </div>
        );
      case 7:
        // 海报
        return (
          <div className={cx('j-share-panel', styles['share-panel'], styles.wx, styles.mask)}>
            <div className={styles.img1}>
              <i
                onClick={() => {
                  /* if (invite) {
                    init()
                  } else {
                    setComState(2)
                  } */
                  init();
                }}
                className={styles.close2}
              />
              <img {...longPressEvent} id='J-pimg' src='' alt='' />
            </div>
            <img className={styles.img2} src={require('@/assets/activity/img23.png')} alt='' />
          </div>
        );
      case 8:
        // 判断被邀请人是否获取到奖励，如果获取到奖励
        return (
          <div className={cx('j-share-panel', styles['share-panel'])}>
            <div className={cx(styles.ct, styles.ct2)}>
              <img className={styles.qrcode1} src={passiveUser?.data?.guideFlowQrCode} alt='' />
              <div className={styles.txt1}>前往公众号，查看解锁内容</div>
            </div>
          </div>
        );
      default:
        return null;
    }
  }
);

export default InviteFriends;
